import { render } from "preact";
import { LocationProvider } from "preact-iso";
import "./tokens/global.css";
import "./app/shell.css";
import "./styles/app.css"; // Marken-Komponenten-CSS (zuletzt → gewinnt)
import { App } from "./app/App";
import { bootstrap } from "./state/auth";
import { registerWithUpdates } from "./app/sw-update";
import "./state/theme"; // Theme-Effekt aktivieren (data-theme setzen)
import "./state/fontscale"; // Schriftgrößen-Effekt aktivieren (--font-scale setzen)

// Token gegen /api/me prüfen, dann rendern. Der Auth-Guard zeigt währenddessen
// den Ladezustand.
void bootstrap();

render(
  <LocationProvider>
    <App />
  </LocationProvider>,
  document.getElementById("app")!,
);

// Service Worker registrieren (PWA / Installierbarkeit) inkl. Update-Erkennung.
// Nur in Produktion, damit der Dev-Server kein veraltetes App-Shell cached.
if (import.meta.env.PROD) {
  registerWithUpdates();
}
